/* eslint-disable eqeqeq */
import React, { useState } from "react";
import { CardTitle } from "../ui/card";
import { Label } from "../ui/label";
import CustomLabelText from "../CustomLabelText";
import SearchSelect from "../SearchSelect";
import { Button } from "../ui/button";
import { Eye, LucidePlusCircle } from "lucide-react";
import { ResponsiveDrawerForm } from "../ResponsiveDrawerForm";
import AddEditRiskAssessment from "../../pages/AML-CTF/Program/RiskAssessment/AddEditRiskAssessment";
import { formatName } from "../../lib/Misc";
import { cddCustomerTypeOptions, cddOptions, riskProfile } from "../../config";
import RiskAssessmentDetailsPopup from "../../pages/AML-CTF/Program/RiskAssessment/RiskAssessmentDetailsPopup";

const AssessmentStep = ({
  values,
  errors,
  setFieldValue,
  handleBlur,
  edit,
  mainData,
  organizationData,
  sectionType,
  setSectionType,
  validateField,
  setTouched,
}) => {
  const [showAssessment, setShowAssessment] = useState(false);
  const [viewAssessment, setViewAssessment] = useState(false);

  const toggleAssessment = () => {
    setShowAssessment(!showAssessment);
  };

  const toggleViewAssessment = () => {
    setViewAssessment(!viewAssessment);
  };
  return (
    <div className="grid gap-4 pt-4">
      <CardTitle className="text-md">
        <div className="flex w-full items-center justify-between">
          <div>Risk Assessment</div>
          {/* <div className="flex gap-2 items-center">
                <Label>
                  <CustomLabelText
                    labelText="KYC"
                    errorField={errors?.is_kyc}
                  />
                </Label>
                <div className="flex items-center gap-4">
                  {mainData?.kyc?.status && (
                  <Button>Reverify</Button>
                )}
                  <Switch
                  name="is_kyc"
                  checked={values?.is_kyc}
                  onCheckedChange={(checked) =>
                    setFieldValue("is_kyc", checked)
                  }
                  onBlur={handleBlur}
                />
                </div>
            </div> */}
        </div>
      </CardTitle>
      {values?.is_kyc && (
        <>
          <div className="grid md:grid-cols-4 gap-4">
            <div className="grid gap-2">
              <div className="min-w-0">
                <Label htmlFor="cdd">
                  <CustomLabelText
                    labelText="CDD Customer Type"
                    errorField={errors?.cdd_customer_type}
                  />
                </Label>
                <div className="relative mt-2">
                  <SearchSelect
                    frameworks={cddCustomerTypeOptions}
                    optionType={"CDD Customer Type"}
                    handleSelect={(e) => {
                      setSectionType(
                        `Onboarding-${e === "1" ? "Ongoing" : "Initial"}`,
                      );
                      setFieldValue("cdd_customer_type", e);
                    }}
                    handleBlur={handleBlur}
                    className={
                      errors?.cdd_customer_type &&
                      `focus-visible:ring-red-500 border-red-500`
                    }
                    disabled={edit && mainData?.kyc?.status ? true : false}
                    initialValue={values?.cdd_customer_type}
                  />
                </div>
              </div>
            </div>

            {values?.cdd_customer_type && (
              <div className="grid gap-2">
                <div className="min-w-0">
                  <Label htmlFor="risk_assessment_id">
                    <CustomLabelText
                      labelText="Risk Assessment"
                      errorField={errors?.risk_assessment_id}
                    />
                  </Label>
                  <div className="relative mt-2">
                    {values?.risk_assessment_id ? (
                      <Button
                        className="w-full justify-start h-9"
                        onClick={(e) => {
                          e.preventDefault();
                          toggleViewAssessment();
                        }}
                      >
                        <span className="flex gap-2 justify-start">
                          <Eye size={18} />
                          Risk Assessment
                        </span>
                      </Button>
                    ) : (
                      <ResponsiveDrawerForm
                        description={""}
                        title={"Add Assessment"}
                        handleOpen={() => {}}
                        popupType={"risk-assessments"}
                        handleClose={() => {
                          setShowAssessment(false);
                        }}
                        buttonText={
                          <div className="flex items-center gap-1">
                            <LucidePlusCircle size={18} />
                            <span>Conduct</span>
                          </div>
                        }
                        className={"overflow-hidden"}
                        open={showAssessment}
                        buttonClassName={"w-full justify-start h-9"}
                        setOpen={setShowAssessment}
                        write={true}
                      >
                        <AddEditRiskAssessment
                          edit={false}
                          toggleShowAddEditRisk={toggleAssessment}
                          id={""}
                          sectionType={sectionType}
                          organizationId={organizationData?.organizationId}
                          customerName={
                            formatName(values?.first_name, values?.last_name) +
                            (values?.business_name
                              ? ` (${values?.business_name})`
                              : "")
                          }
                          customerType={
                            values?.type == 2 ? "Non Individual" : "Individual"
                          }
                          setFieldValue={setFieldValue}
                          fetchRiskData={() => {}}
                          setTouched={setTouched}
                          validateField={validateField}
                        />
                      </ResponsiveDrawerForm>
                    )}
                  </div>
                </div>
              </div>
            )}

            <div className="grid gap-2">
              <div className="min-w-0">
                <Label htmlFor="risk">
                  <CustomLabelText
                    labelText="Risk Profile"
                    errorField={errors?.risk}
                  />
                </Label>
                <div className="relative mt-2">
                  <SearchSelect
                    frameworks={riskProfile}
                    optionType={"Risk Profile"}
                    handleSelect={(e) => {
                      setFieldValue("risk", e);
                    }}
                    handleBlur={handleBlur}
                    className={
                      errors?.risk &&
                      `focus-visible:ring-red-500 border-red-500`
                    }
                    disabled={edit && mainData?.kyc?.status ? true : false}
                    initialValue={values?.risk}
                  />
                </div>
              </div>
            </div>

            <div className="grid gap-2">
              <div className="min-w-0">
                <Label htmlFor="cdd">
                  <CustomLabelText
                    labelText="CDD Type"
                    errorField={errors?.cdd}
                  />
                </Label>
                <div className="relative mt-2">
                  <SearchSelect
                    frameworks={cddOptions}
                    optionType={"CDD Type"}
                    handleSelect={(e) => {
                      setFieldValue("cdd", e);
                    }}
                    handleBlur={handleBlur}
                    className={
                      errors?.cdd && `focus-visible:ring-red-500 border-red-500`
                    }
                    disabled={edit && mainData?.kyc?.status ? true : false}
                    initialValue={values?.cdd}
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {viewAssessment && (
        <RiskAssessmentDetailsPopup
          showView={viewAssessment}
          id={values?.risk_assessment_id}
          toggleShowModal={toggleViewAssessment}
          setShowView={setViewAssessment}
          sectionType={sectionType}
        />
      )}
    </div>
  );
};

export default AssessmentStep;
